import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import {
  faCopy,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCheckCircle,
  faTimes,
  faPlus,
  faPlusSquare,
  faSave,
  faEnvelope,
  faPencilAlt,
  faSearch,
  faSyncAlt,
  faHistory,
  faUndoAlt,
  faArrowLeft,
  faArrowRight,
  faBars,
  faLock,
  faLockOpen,
  faExternalLinkSquareAlt,
  faSlidersH,
  faLayerGroup,
  faComment,
  faFax,
  faPenSquare,
  faTrashAlt,
  faPhone
} from '@fortawesome/pro-solid-svg-icons';

export function FasCopy(props) {
  return <FontAwesomeIcon icon={faCopy} {...props} />;
} // documents

export function FasExclamation(props) {
  return <FontAwesomeIcon icon={faExclamation} {...props} />;
}

export function FasExclamationCircle(props) {
  return <FontAwesomeIcon icon={faExclamationCircle} {...props} />;
}

export function FasExclamationTriangle(props) {
  return <FontAwesomeIcon icon={faExclamationTriangle} {...props} />;
}

export function FasInfoCircle(props) {
  return <FontAwesomeIcon icon={faInfoCircle} {...props} />;
}

export function FasCheckCircle(props) {
  return <FontAwesomeIcon icon={faCheckCircle} {...props} />;
} // approved

export function FasTimes(props) {
  return <FontAwesomeIcon icon={faTimes} {...props} />;
} // close

export function FasPlus(props) {
  return <FontAwesomeIcon icon={faPlus} {...props} />;
} // add

export function FasPlusSquare(props) {
  return <FontAwesomeIcon icon={faPlusSquare} {...props} />;
} // add item

export function FasSave(props) {
  return <FontAwesomeIcon icon={faSave} {...props} />;
}

export function FasEnvelope(props) {
  return <FontAwesomeIcon icon={faEnvelope} {...props} />;
}

export function FasPencilAlt(props) {
  return <FontAwesomeIcon icon={faPencilAlt} {...props} />;
}

export function FasSearch(props) {
  return <FontAwesomeIcon icon={faSearch} {...props} />;
}

export function FasSyncAlt(props) {
  return <FontAwesomeIcon icon={faSyncAlt} {...props} />;
}

export function FasHistory(props) {
  return <FontAwesomeIcon icon={faHistory} {...props} />;
}

export function FasUndoAlt(props) {
  return <FontAwesomeIcon icon={faUndoAlt} {...props} />;
}

export function FasArrowLeft(props) {
  return <FontAwesomeIcon icon={faArrowLeft} {...props} />;
}

export function FasArrowRight(props) {
  return <FontAwesomeIcon icon={faArrowRight} {...props} />;
}

export function FasBars(props) {
  return <FontAwesomeIcon icon={faBars} {...props} />;
} // hamburger menu

export function FasLock(props) {
  return <FontAwesomeIcon icon={faLock} {...props} />;
}

export function FasUnLock(props) {
  return <FontAwesomeIcon icon={faLockOpen} {...props} />;
}

export function FasTrash(props) {
  return <FontAwesomeIcon icon={faTrashAlt} {...props} />;
}

export function FasComment(props) {
  return <FontAwesomeIcon icon={faComment} {...props} />;
}

export function FasExternalLinkSquareAlt(props) {
  return <FontAwesomeIcon icon={faExternalLinkSquareAlt} {...props} />;
} // internal link

export function FasSlidersH(props) {
  return <FontAwesomeIcon icon={faSlidersH} {...props} />;
} // additional data filters

export function FasLayerGroup(props) {
  return <FontAwesomeIcon icon={faLayerGroup} {...props} />;
}

export function FasFax(props) {
  return <FontAwesomeIcon icon={faFax} {...props} />;
}

export function FasPhone(props) {
  return <FontAwesomeIcon icon={faPhone} {...props} />;
}

export function FasPenSquare(props) {
  return <FontAwesomeIcon icon={faPenSquare} {...props} />;
}

export function FarClone(props) {
  return <FontAwesomeIcon icon={faClone} {...props} />;
} // open in new tab
